export default __webpack_public_path__ + "static/media/list_main_10_2.c7a044a5.jpg";